var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3C6.14873 3 1 8.14873 1 14.5C1 20.8513 6.14873 26 12.5 26C18.8513 26 24 20.8513 24 14.5C24 8.14873 18.8513 3 12.5 3ZM12.5 4.27778C18.1456 4.27778 22.7222 8.85442 22.7222 14.5C22.7222 20.1456 18.1456 24.7222 12.5 24.7222C6.85442 24.7222 2.27778 20.1456 2.27778 14.5C2.27778 8.85442 6.85442 4.27778 12.5 4.27778Z",
    fill: "#FFD4A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 17.2344C12.5347 16.1927 12.7604 15.4115 13.2813 14.8906C14.0625 14.1094 13.887 14.4086 14.8438 13.3281C15.8005 12.2477 16.4062 11.7656 16.4062 10.6465C16.4062 8.54862 14.6979 7.07813 12.5104 7.07813C10.2604 7.07812 8.59375 8.66626 8.59375 10.6661",
    stroke: "#FFD4A3",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.5781V21.1406",
    stroke: "#FFD4A3",
    strokeWidth: 1.296,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFaq);
export default __webpack_public_path__ + "static/media/ico_faq.4309f340d8d35bf10816e3cf68912f4c.svg";
export { ForwardRef as ReactComponent };